import { render, staticRenderFns } from "./bank-report.vue?vue&type=template&id=0c843803"
import script from "./bank-report.vue?vue&type=script&lang=js"
export * from "./bank-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports